import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  audit: {
    id: 'audit',
    defaultMessage: 'Audit',
  },
  auditList: {
    id: 'auditList',
    defaultMessage: 'Audit Log',
  },

  label: {
    employee: {
      id: 'auditList.employee',
      defaultMessage: 'Employee Name',
    },
    company: {
      id: 'auditList.company',
      defaultMessage: 'Company Name',
    },
    date: {
      id: 'auditList.date',
      defaultMessage: 'Date Time',
    },
    module: {
      id: 'auditList.module',
      defaultMessage: 'Module',
    },
    action: {
      id: 'auditList.action',
      defaultMessage: 'Action',
    },
  },
});
